import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Icon } from 'assets/img/icons/cardIcons/contactInfo.svg';
import { Col, Row, Button, Form, Input, Divider, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getDebtTypesCompany, getDebtTypesPerson } from '../../../../store/entities/administration/thunks';
import LoadingSpinner from '../../../../components/reusable/LoadingSpinner';
import { InputDataRow } from '../../../../components/reusable/CompanyDataCard';
import useAllowedFeature from '../../../../hooks/user/useAllowedFeature';
import Modal from '../../../../components/reusable/Modal';
import { IncreaseDecreaseDebtModal } from '../modals';
import { BlockHeader } from '../../../../components/reusable/BlockHeader';
const { Text } = Typography;

export const SelectedDebtorSection = memo(({ companyOrPerson }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { debtTypesCompany, debtTypesPerson, selectedDebtor, companyOrPersonDebtsLoading } = useSelector(
    state => state.administration
  );

  const isDeleteAllowed = useAllowedFeature('/product/administrationdeletedebt/', false);

  useEffect(() => {
    if (companyOrPerson === 'company') {
      !debtTypesCompany.length && dispatch(getDebtTypesCompany());
    } else {
      !debtTypesPerson.length && dispatch(getDebtTypesPerson());
    }
  }, []);

  useEffect(() => {
    if (selectedDebtor) {
      form.setFieldsValue(selectedDebtor);
    }
  }, [selectedDebtor, form]);

  if (!selectedDebtor) return null;

  return (
    <LoadingSpinner size="small" spinning={companyOrPersonDebtsLoading}>
      <>
        <IncreaseDecreaseDebtModal companyOrPerson={companyOrPerson} />
        <Modal
          onCancel={() => dispatch({ type: 'REMOVE_SELECTED_DEBTOR' })}
          isOpen
          width={840}
          size="md"
          className="new-debt"
          secondaryTitle={
            <BlockHeader
              title={t(
                `administration.debtManagement.${
                  companyOrPerson === 'company' ? 'company' : 'individual'
                }.edditDebt.title`
              )}
              icon={<Icon style={{ height: 30, width: 30 }} />}
            />
          }
        >
          <Form
            form={form}
            initialValues={selectedDebtor ?? {}}
            labelCol={{ span: 24 }}
            className="new-debt"
            requiredMark={false}
            layout="inline"
          >
            <Row gutter={[16, 0]} style={{ marginBottom: 16 }}>
              <Col span={24}>
                <InputDataRow
                  label={t(
                    `administration.debtManagement.${
                      companyOrPerson === 'company' ? 'company' : 'individual'
                    }.edditDebt.companyName`
                  )}
                  input={
                    <>
                      <Form.Item name="companyName" hidden>
                        <Input />
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {() => <Text>{form.getFieldValue('companyName')}</Text>}
                      </Form.Item>
                    </>
                  }
                />
              </Col>

              <Divider className="space-vertical-xs" />

              <Col span={24}>
                <InputDataRow
                  label={t(
                    `administration.debtManagement.${
                      companyOrPerson === 'company' ? 'company' : 'individual'
                    }.edditDebt.debtId`
                  )}
                  input={
                    <>
                      <Form.Item name="debtId" hidden>
                        <Input />
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {() => <Text>{form.getFieldValue('debtId')}</Text>}
                      </Form.Item>
                    </>
                  }
                />
              </Col>

              <Col span={24}>
                <InputDataRow
                  label={t(
                    `administration.debtManagement.${
                      companyOrPerson === 'company' ? 'company' : 'individual'
                    }.edditDebt.submissionDate`
                  )}
                  input={
                    <>
                      <Form.Item name="submissionDate" hidden>
                        <Input />
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {() => <Text>{form.getFieldValue('submissionDate')}</Text>}
                      </Form.Item>
                    </>
                  }
                />
              </Col>

              <Col span={24}>
                <InputDataRow
                  label={t(
                    `administration.debtManagement.${
                      companyOrPerson === 'company' ? 'company' : 'individual'
                    }.edditDebt.dateIncurrence`
                  )}
                  input={
                    <>
                      <Form.Item name="dateIncurrence" hidden>
                        <Input />
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {() => <Text>{form.getFieldValue('dateIncurrence')}</Text>}
                      </Form.Item>
                    </>
                  }
                />
              </Col>

              <Col span={24}>
                <InputDataRow
                  label={t(
                    `administration.debtManagement.${
                      companyOrPerson === 'company' ? 'company' : 'individual'
                    }.edditDebt.debtType`
                  )}
                  input={
                    <>
                      <Form.Item name="debtType" hidden>
                        <Input />
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {() => <Text>{form.getFieldValue('debtType')}</Text>}
                      </Form.Item>
                    </>
                  }
                />
              </Col>

              {/*<Col span={24}>*/}
              {/*  <InputDataRow*/}
              {/*    */}
              {/*    label={t(*/}
              {/*      `administration.debtManagement.${*/}
              {/*        companyOrPerson === 'company' ? 'company' : 'individual'*/}
              {/*      }.edditDebt.originalAmount`*/}
              {/*    )}*/}
              {/*    input={*/}
              {/*      <>*/}
              {/*        <Form.Item name="originalAmount" hidden>*/}
              {/*          <Input />*/}
              {/*        </Form.Item>*/}
              {/*        <Form.Item shouldUpdate noStyle>*/}
              {/*          {() => <Text>{form.getFieldValue('originalAmount')}</Text>}*/}
              {/*        </Form.Item>*/}
              {/*      </>*/}
              {/*    }*/}
              {/*  />*/}
              {/*</Col>*/}

              <Col span={24}>
                <InputDataRow
                  label={t(
                    `administration.debtManagement.${
                      companyOrPerson === 'company' ? 'company' : 'individual'
                    }.edditDebt.amount`
                  )}
                  input={
                    <>
                      <Form.Item name="amount" hidden>
                        <Input />
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {() => <Text>{form.getFieldValue('amount')}</Text>}
                      </Form.Item>
                    </>
                  }
                />
              </Col>
            </Row>
            <Row
              gutter={[0, 16]}
              style={{ margin: '20px -16px 0 -16px', width: 'calc(100% + 32px)' }}
              justify="space-between"
            >
              <Col>
                <Row gutter={[16, 16]}>
                  {!selectedDebtor?.dateCoverage && (
                    <Col>
                      <Button
                        onClick={() => dispatch({ type: 'TOGGLE_COVERED_PARTIALLY_COVERED_MODAL', payload: true })}
                        size="small"
                      >
                        {t('common.coveredOrPartially')}
                      </Button>
                    </Col>
                  )}

                  {!selectedDebtor?.dateCoverage && (
                    <Col>
                      <Button
                        onClick={() => dispatch({ type: 'TOGGLE_INCREASE_DEBT_MODAL', payload: true })}
                        size="small"
                      >
                        {t('common.increaseDebt')}
                      </Button>
                    </Col>
                  )}

                  <Col>
                    <Button
                      onClick={() => dispatch({ type: 'TOGGLE_INFORM_ABOUT_INCORRECT_DEBT_MODAL', payload: true })}
                      size="small"
                    >
                      {t('administration.debtManagement.informAboutIncorrectDebt.button')}
                    </Button>
                  </Col>

                  {isDeleteAllowed && (
                    <Col>
                      <Button
                        onClick={() => dispatch({ type: 'TOGGLE_DELETE_DEBT_MODAL', payload: true })}
                        size="small"
                      >
                        {t('administration.debtManagement.deleteDebt.button')}
                      </Button>
                    </Col>
                  )}
                </Row>
              </Col>

              <Col align="end" justify="end">
                <Button size="small" onClick={() => dispatch({ type: 'REMOVE_SELECTED_DEBTOR' })} className="save">
                  {t('global.back')}
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    </LoadingSpinner>
  );
});
